import { useState } from 'react'
import { PageLoader } from '../../shared/ui/Spinner'
import { RosHeader } from './ros/RosHeader'
import { RosKpiCards } from './ros/RosKpiCards'
import { RosFunnelDonut } from './ros/RosFunnelDonut'
import { RosOutcomeCard } from './ros/RosOutcomeCard'
import { RosBuyersTable } from './ros/RosBuyersTable'
import { RosTypeSplit } from './ros/RosTypeSplit'
import { RosProjectsCard } from './ros/RosProjectsCard'
import { RosDynamicsChart } from './ros/RosDynamicsChart'
import { RosDrilldownModal } from './ros/RosDrilldownModal'
import { useRosDashboard, useRosFilters, useRosPeriod } from './ros/useRosDashboard'
import type { RosDrillKind } from './ros/types'
import { NewsFeedWidget } from '../news/NewsFeedWidget'

// Дашборд РОЗ (этап 3): аналитика квотирования по команде + счёт/отказ.
// Спека — stages-3-5-plan.md §5 «Дашборд РОЗ (расширение)». Денежная аналитика
// закупки (CNY/поставщики) — отдельный будущий блок «Закупка позиций».

export function RosDashboard() {
  const { key: period, setKey } = useRosPeriod()
  const { filters, patch } = useRosFilters()
  const { data, isLoading, isError, dataUpdatedAt, refetch } = useRosDashboard(period, filters)
  // Модалка-список за период («Ушло в счёт»/«Ушло в отказ»/«Проквотировано»).
  const [drill, setDrill] = useState<RosDrillKind | null>(null)

  if (isLoading) return <PageLoader />
  if (isError || !data) {
    return (
      <div className="bg-white rounded-2xl border border-red-200 p-6 text-center">
        <p className="text-sm text-red-700 mb-2">Не удалось загрузить дашборд</p>
        <button
          onClick={() => refetch()}
          className="px-3 py-1.5 text-sm rounded-lg bg-red-600 text-white hover:bg-red-700"
        >
          Повторить
        </button>
      </div>
    )
  }

  return (
    <div className="space-y-4">
      <RosHeader
        teamSize={data.team.length}
        period={period}
        onPeriodChange={setKey}
        fetchedAt={dataUpdatedAt}
        filters={filters}
        onFiltersChange={patch}
        team={data.team}
      />

      <RosKpiCards kpi={data.kpi} filters={filters} onOpenDrill={setDrill} />

      <div className="grid grid-cols-1 lg:grid-cols-5 gap-4">
        <div className="lg:col-span-3">
          <RosFunnelDonut funnel={data.funnel} filters={filters} />
        </div>
        <div className="lg:col-span-2">
          <RosOutcomeCard outcome={data.outcome} onOpenDrill={setDrill} />
        </div>
      </div>

      <RosBuyersTable rows={data.byBuyer} filters={filters} />

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
        <RosTypeSplit
          tekuchka={data.typeSplit.tekuchka}
          project={data.typeSplit.project}
          filters={filters}
        />
        <RosProjectsCard items={data.projects.items} total={data.projects.total} />
      </div>

      <RosDynamicsChart points={data.dynamics} />

      <NewsFeedWidget />

      {drill && (
        <RosDrilldownModal
          kind={drill}
          period={period}
          filters={filters}
          onClose={() => setDrill(null)}
        />
      )}
    </div>
  )
}
